import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import AllSportsHubsLogo from './pages/ASH Logo (1).png';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isRegistered, setIsRegistered] = useState(false);
  const { register, loading, signInWithGoogle } = useAuth();
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    try {
      const result = await register(formData.name, formData.email, formData.password);

      if (result.success) {
        setSuccess(result.message || 'Registration successful. Check your email for verification.');
        setIsRegistered(true);
        setFormData({ name: '', email: '', password: '' });
      } else {
        setError(result.message || 'Registration failed.');
      }
    } catch (err) {
      console.error(err);
      setError('An unexpected error occurred. Please try again.');
    }
  };

  const handleGoogleSignUp = async () => {
    setError('');
    setSuccess('');

    try {
      const result = await signInWithGoogle();
      if (!result.success) {
        setError(result.message || 'Google sign-up failed.');
      }
    } catch (err) {
      console.error(err);
      setError('An unexpected error occurred with Google sign up.');
    }
  };

  const GoogleButton = () => (
    <button
      onClick={handleGoogleSignUp}
      disabled={loading || isRegistered}
      type="button"
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        backgroundColor: 'white',
        border: '1px solid #dadce0',
        borderRadius: '25px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        color: '#3c4043',
        cursor: loading || isRegistered ? 'not-allowed' : 'pointer',
        marginBottom: '1.5rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        transition: 'all 0.18s ease',
        opacity: loading || isRegistered ? 0.6 : 1,
      }}
      onMouseEnter={(e) => {
        if (!loading && !isRegistered) {
          e.currentTarget.style.boxShadow = '0 6px 20px rgba(30,116,199,0.08)';
          e.currentTarget.style.backgroundColor = '#f8f9fa';
        }
      }}
      onMouseLeave={(e) => {
        if (!loading && !isRegistered) {
          e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
          e.currentTarget.style.backgroundColor = 'white';
        }
      }}
      onMouseDown={(e) => {
        if (!loading && !isRegistered) e.currentTarget.style.transform = 'scale(0.995)';
      }}
      onMouseUp={(e) => {
        if (!loading && !isRegistered) e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
      </svg>
      Sign up with Google
    </button>
  );

  const Divider = () => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      margin: '1.5rem 0',
      gap: '1rem'
    }}>
      <div style={{ flex: 1, height: '1px', backgroundColor: '#dadce0' }} />
      <span style={{ color: '#5f6368', fontSize: '14px' }}>or</span>
      <div style={{ flex: 1, height: '1px', backgroundColor: '#dadce0' }} />
    </div>
  );

  const SuccessActions = () => (
    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
      <p style={{
        fontSize: '14px',
        color: '#666',
        marginBottom: '1rem',
        lineHeight: '1.4'
      }}>
        Check your email and click the verification link to activate your account.
      </p>

      <div style={{
        display: 'flex',
        gap: '1rem',
        justifyContent: 'center',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={() => navigate('/login')}
          style={{
            backgroundColor: '#4285F4',
            color: 'white',
            border: 'none',
            borderRadius: '25px',
            padding: '10px 20px',
            fontSize: '14px',
            cursor: 'pointer',
            fontWeight: '500',
            transition: 'transform 0.12s, background-color 0.12s',
            boxShadow: '0 8px 24px rgba(30,116,199,0.12)'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#3367D6'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#4285F4'}
          onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.98)'}
          onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          Go to Login
        </button>

        <button
          onClick={() => {
            setIsRegistered(false);
            setSuccess('');
            setError('');
          }}
          style={{
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '25px',
            padding: '10px 20px',
            fontSize: '14px',
            cursor: 'pointer',
            fontWeight: '500',
            transition: 'transform 0.12s, background-color 0.12s',
            boxShadow: '0 6px 18px rgba(0,0,0,0.08)'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#5a6268'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#6c757d'}
          onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.98)'}
          onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          Register Another Account
        </button>
      </div>
    </div>
  );

  const handleLogoClick = () => navigate('/');

  return (
    <div className="auth-container animate-fade-in-up" style={{ maxWidth: 480, margin: '0 auto', padding: '2rem' }}>
      <div 
        style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          marginBottom: '1.5rem', 
          cursor: 'pointer' 
        }}
        onClick={handleLogoClick}
      >
        <img 
          src={AllSportsHubsLogo} 
          alt="All Sports Hubs Logo" 
          style={{ height: '125px', width: 'auto', objectFit: 'contain' }} 
        />
      </div>

      <h2 style={{ textAlign: 'center', marginBottom: '1rem', color: '#1e74c7' }}>Register</h2>

      {error && (
        <div style={{
          color: 'red',
          backgroundColor: '#ffebee',
          padding: '10px',
          borderRadius: '4px',
          marginBottom: '1rem',
          border: '1px solid #ffcdd2'
        }}>
          {error}
        </div>
      )}

      {success && (
        <div style={{
          color: 'green',
          backgroundColor: '#e8f5e8',
          padding: '10px',
          borderRadius: '4px',
          marginBottom: '1rem',
          border: '1px solid #c8e6c9'
        }}>
          {success}
        </div>
      )}

      {isRegistered ? (
        <SuccessActions />
      ) : (
        <>
          <GoogleButton />
          <Divider />

          <form onSubmit={handleRegister} style={{ display: 'flex', flexDirection: 'column' }}>
            <input
              type="text"
              placeholder="Full Name"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              disabled={loading}
              style={{
                padding: '12px',
                borderRadius: 8,
                border: '1px solid #cfe9ff',
                marginBottom: '0.75rem',
                fontSize: '14px'
              }}
            />

            <input
              type="email"
              placeholder="Email"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              disabled={loading}
              style={{
                padding: '12px',
                borderRadius: 8,
                border: '1px solid #cfe9ff',
                marginBottom: '0.75rem',
                fontSize: '14px'
              }}
            />

            <input
              type="password"
              placeholder="Password (min 6 characters)"
              required
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              disabled={loading}
              style={{
                padding: '12px',
                borderRadius: 8,
                border: '1px solid #cfe9ff',
                marginBottom: '0.75rem',
                fontSize: '14px'
              }}
            />

            <button
              type="submit"
              disabled={loading}
              style={{
                marginTop: '0.5rem',
                padding: '12px',
                borderRadius: 28,
                background: 'linear-gradient(90deg,#1e74c7,#7fc3f2)',
                color: 'white',
                border: 'none',
                fontSize: '16px',
                fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.6 : 1,
                boxShadow: '0 8px 24px rgba(30,116,199,0.18)',
                transition: 'transform 0.12s, box-shadow 0.12s'
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(30,116,199,0.2)';
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(30,116,199,0.18)';
                }
              }}
              onMouseDown={(e) => {
                if (!loading) e.currentTarget.style.transform = 'scale(0.995)';
              }}
              onMouseUp={(e) => {
                if (!loading) e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              {loading ? 'Registering...' : 'Register'}
            </button>
          </form>

          <p style={{ marginTop: '1rem', textAlign: 'center', color: '#374151' }}>
            Already have an account?{' '}
            <span
              onClick={() => !loading && navigate('/login')}
              className="switch-link"
              style={{
                cursor: loading ? 'not-allowed' : 'pointer',
                color: loading ? '#ccc' : '#1e74c7',
                textDecoration: 'underline',
                opacity: loading ? 0.6 : 1
              }}
            >
              Login
            </span>
          </p>
        </>
      )}

      <div style={{ display: 'flex', justifyContent: 'center' }}>
      </div>
    </div>
  );
};

export default Register;